import { MaxAllowedCharsInHotelSpecialRequest } from '../constants';

export const getHotelRequestLimit = ({ maxCharsHotelSpecialRequest, advisorId, value }) => {
  const maxChars = maxCharsHotelSpecialRequest ?? MaxAllowedCharsInHotelSpecialRequest;

  const advisorLength = advisorId?.length || 0;
  const requestLength = value?.length || 0;

  const maxRequestLength = Math.max(maxChars - advisorLength, 0);

  const totalUsed = advisorLength + requestLength;
  const remaining = maxChars - totalUsed;

  return {
    maxChars,
    advisorLength,
    requestLength,
    maxRequestLength,
    totalUsed,
    remaining,
    isOverLimit: remaining < 0,
  };
};
